/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import MobileFlyoutMegaMenuButton from './MobileFlyoutMegaMenuButton';
import MobileFlyoutMegaMenuItem from './MobileFlyoutMegaMenuItem';

import { MobileFlyoutMegaMenuProps } from './_props';

import { useMobileFlyout } from '../hooks/useMobileFlyout';

import useMobileFlyoutMegaMenuTheme from './themes';

/**
 * MobileFlyoutMegaMenu Component
 */

function MobileFlyoutMegaMenu({ subMenuItem }: MobileFlyoutMegaMenuProps) {
  const { mobileFlyoutActiveItem, toggleMobileFlyoutActiveItem } = useMobileFlyout();

  const { megaMenuClasses } = useMobileFlyoutMegaMenuTheme();

  if (subMenuItem.children.length === 0) return null;

  const subMenuMainItem = subMenuItem.children[0];
  const subMenuSubItems = subMenuItem.children.slice(1);

  return (
    <>
      <MobileFlyoutMegaMenuButton subMenuMainItem={subMenuMainItem} />

      <ul className={megaMenuClasses}>
        {subMenuSubItems.map((subMenuSubItem, subMenuSubItemIndex) => (
          <MobileFlyoutMegaMenuItem
            key={subMenuSubItem.id}
            subMenuSubItem={subMenuSubItem}
            subMenuSubItemIndex={subMenuSubItemIndex}
            mobileFlyoutActiveItem={mobileFlyoutActiveItem}
            toggleMobileFlyoutActiveItem={toggleMobileFlyoutActiveItem}
          />
        ))}
      </ul>
    </>
  );
}

/**
 * Exports
 */

export default MobileFlyoutMegaMenu;
